export const FEATURE_FLAG_SHOW_FALL25_COUPON = true;
